import { Ajax } from "../../Common/Ajax";
import { CookieHelper } from "../../Common/CookieHelper";
import { GlobalData } from "../../Common/GlobalData";
import { HtmlHelpers } from "../../Common/HtmlHelpers";
import { Notification, TemplateHelpers } from "../../Common/KendoHelpers";

export class AccountList {
    public static readonly GRID = '#accountListGrid';

    private static readonly REPORT_DATE = '#closingDate';

    private static _instance: AccountList;
    public static getInstance() {
        return this._instance || (this._instance = new this());
    }

    private grid!: kendo.ui.Grid;

    private constructor() { }

    public init() {
        if (!this.grid) {
            this.initGrid();
        }
        else {
            this.grid.dataSource.read();
        }
    }

    private initGrid() {
        const account = CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE);
        const url = GlobalData.URL_BASE +
            GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_ACCOUNT_LIST + "?account=" + account;

        this.grid = $(AccountList.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: url,
                },
                schema: {
                    model: {
                        fields: {
                            symbol: { type: 'string' },
                            risk: { type: 'number' },
                            readyToBuyList: { type: 'boolean' },
                            totalRank: { type: 'number' },
                            issueNo: { type: 'number' },
                            personalUrl: { type: 'string' },
                        },
                    },
                },
            },
            dataBound: () => {
                const data = $(AccountList.GRID).data('kendoGrid')!.dataSource.data();
                if (data && data.length > 0) {
                    $(AccountList.REPORT_DATE).html(
                        HtmlHelpers.getFormattedDate(data[0].closingDate));
                }

                this.defineEvents();
                $(AccountList.GRID).show();
            },

            height: 915,
            groupable: false,
            navigatable: true,
            sortable: true,
            filterable: false,
            pageable: false,
            resizable: true,
            detailInit: this.openDetail,
            columns: [
                {
                    field: 'symbol',
                    title: 'Symbol',
                    width: '10%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: center; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '25%',
                    headerAttributes: { "class": "table-header-cell", style: "text-align: left; font-size: 13px; font-weight: bold; color: navy" },
                    attributes: { "class": "table-cell", style: "text-align: left; font-size: 12px" },
                },
                {
                    field: 'sumQtyOwn',
                    title: 'Qty',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                },
                {
                    field: "costPerShare",
                    title: "Cost/Share",
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "close",
                    title: "Close",
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "marketValue",
                    title: "Market",
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "sumCostBasis",
                    title: "CostBasis",
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:c2}',
                },
                {
                    field: "gainLoss",
                    title: "GainLoss$",
                    width: '10%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getColorCurrencyTemplate('gainLoss')),
                },
                {
                    field: "gainLossPct",
                    title: "GainLoss%",
                    width: '7%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getColorPercentTemplate('gainLossPct')),
                },
                {
                    field: "risk",
                    title: "Risk",
                    width: '7%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    format: '{0:p1}',
                }, {
                    field: 'readyToBuyList',
                    title: 'Ready<br>to Buy<br>List',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getCheckboxTemplate('readyToBuyList')),
                }, {
                    field: 'totalRank',
                    title: 'Total<br>Rank',
                    width: '7%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                }, {
                    field: 'issueNo',
                    title: 'VL<br>Issue',
                    width: '6%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                }, {
                    field: 'personalUrl',
                    title: 'VL<br>Per<br>Rpt',
                    width: '5%',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { "class": "table-cell", style: "text-align: center; font-size: 12px" },
                    template: kendo.template(TemplateHelpers.getValueLineReportTemplate('personalUrl')),
                }
            ]
        }).data('kendoGrid')!;
    }

    private defineEvents() {
        // Update value of the field when user clicks a checkbox.
        $('.readyToBuyListCheckbox').off('click').on('click', (e: any) => {
            this.onReadyToBuyClick(e);
        });
    }

    private openDetail(e: any) {
        const account = CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE);
        const urlSuffix = GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_ACCOUNT_LIST +
            "/Detail?account=" + account + '&symbol=' + e.data.symbol;

        const success = (data: any) => {
            if (e.detailCell != null) {
                e.detailCell.html(data);
            }
        };

        const error = (x: any, y: any, z: any) => {
            e.detailCell = null;
        }

        Ajax.invoke(urlSuffix, 'GET', null, success, error);
    }

    private onReadyToBuyClick(e: any) {
        const dataItem = this.getClosestDataItem(e) as any;
        dataItem.readyToBuyList = e.target.checked;

        this.updateReadyToBuy(dataItem);
    }

    private updateReadyToBuy(dataItem: any) {
        const success = () => {
            this.grid.dataSource.read();
        };

        const error = (x: any) => {
            const msg = new Notification();
            msg.error(x.responseJSON);
        };

        Ajax.invoke(GlobalData.URL_SUFFIX_PORTFOLIO_ACCOUNT_MANAGER_WATCHLIST +
            '/ReadyToBuyList?account=' + CookieHelper.get(GlobalData.PORTFOLIO_ACCOUNT_SELECTOR_COOKIE),
            'PUT', dataItem, success, error);
    }

    private getClosestDataItem(e: any) {
        return this.grid.dataItem($(e.target).closest('tr'));
    }
}
